import { createAsyncThunk } from '@reduxjs/toolkit'
import { LoginPayload, LoginResponse, LoginSuccessPayload } from 'store/auth/thunks/types.ts'
import { getAxiosRequestConfig, newRequest } from 'utils/request.ts'
import { Methods, NewResponse } from 'types/request.ts'
import { Paths } from 'types/paths.ts'
import { setTokens } from 'utils/sessionStorageService.ts'
import { INTERNAL_USER_ROLES } from '@boltenergy-be/shared'

export const login = createAsyncThunk<LoginSuccessPayload, LoginPayload>('auth/login', async ({ email, password, navigate }, thunkAPI) => {
  try {
    const { success, data, message }: NewResponse<LoginResponse> = await newRequest(
      getAxiosRequestConfig(Methods.POST, '/auth/internal/login', { email, password })
    )

    if (!success || !data?.tokens) {
      return thunkAPI.rejectWithValue(message ?? 'login')
    }

    // Save the tokens & navigate to Dashboard
    setTokens(data.tokens)

    navigate(data.role === INTERNAL_USER_ROLES.dashboard ? Paths.GOALS_DASHBOARD : Paths.DATA_DASHBOARD)

    return { email: email, role: data?.role }
  } catch (err) {
    const { message } = err as Error
    return thunkAPI.rejectWithValue(message)
  }
})
